export default "__VITE_ASSET__$zqWenWD__"